import { handlePointerDown} from '../../lib/modal-helper';
import { useSelector, useDispatch } from 'react-redux';
import { selectAllStrings } from '../language/languageSlice';
import CampsiteIcon from '../../app/icons/CampsiteIcon';
import ServiceAreaIcon from '../../app/icons/ServiceAreaIcon';
import ParkingAreaIcon from '../../app/icons/ParkingAreaIcon';
import ClubBenefitIcon from '../../app/icons/ClubBenefitIcon';
import { useState, useRef, useEffect } from 'react';
import '../../stylesheets/SearchModal.css';
import { Loader } from "@googlemaps/js-api-loader";
import { setUserPosition } from '../map/mapSlice';
import { getPosition } from '../../api/mobile';
import constants from '../../constants';


const SearchModal = ({onGoBack, onApplyFilters, show, defaultLocation = null,
        defaultCampsites = true, defaultServiceAreas = true,
        defaultParkingAreas = true,
        defaultClubBenefits = true, defaultAttractions = false}) => {

    const strings = useSelector(selectAllStrings);
    const [poiKeyword, setPoiKeyword] = useState('');
    const onPoiKeywordChanged = (event) => {
        if (poiKeyword != event.target.value) {
            setPoiKeyword(event.target.value);
        }
    };
    const [location, setLocation] = useState(null);
    const [campsites, setCampsites] = useState(true);
    const [serviceAreas, setServiceAreas] = useState(true);
    const [parkingAreas, setParkingAreas] = useState(true);
    const [clubBenefits, setClubBenefits] = useState(true);
    const [attractions, setAttractions] = useState(false);
    const [disabledAccessibility, setDisabledAccessibility] = useState(false);
    const [petsAllowed, setPetsAllowed] = useState(false);
    const [water, setWater] = useState(false);
    const [cockpit, setCockpit] = useState(false);
    const [electricity, setElectricity] = useState(false);

    const [inited, setInited] = useState(false);
    const [locationKeyword, setLocationKeyword] = useState('');
    const dispatch = useDispatch();

    const onLocationKeywordChanged = (event) => {
        if (locationKeyword != event.target.value) {
            setLocationKeyword(event.target.value);
        }

        if (event.target.value === '') {
            setLocation(defaultLocation);
        }
    };

    const applyFilters = (location) => {
        let filters = {
            poiKeyword: poiKeyword,
            location: new window.Google.maps.LatLng(location.lat, location.lng),
            campsites: campsites,
            serviceAreas: serviceAreas,
            parkingAreas: parkingAreas,
            clubBenefits: clubBenefits,
            attractions: attractions,
            disabledAccessibility: disabledAccessibility,
            petsAllowed: petsAllowed,
            water: water,
            cockpit: cockpit,
            electricity: electricity
        };
        dispatch(setUserPosition(location));

        onApplyFilters(filters, locationRef.current.value);
    };

    const onApplyClicked = async (event) => {
        event.preventDefault();

        if (!location) {
            let newLocation = await getPosition();
            setLocation(newLocation);
            applyFilters(newLocation);

        } else {
            applyFilters(location);
        }

    };
    const [canApply, setCanApply] = useState(true);
    const locationRef = useRef(null);

    const additionalOptions = {
        libraries: ["places"]
    };
    
    
    const loader = new Loader({
        apiKey: constants.maps_api_key,
        version: "weekly",
        ...additionalOptions
    });
    useEffect(() => {
        if (show && !inited) {
            loader.load().then(() => {
                const options = {
                    fields: ["formatted_address", "geometry", "name"]

                };
                window.Google = google;
                const autocomplete = new google.maps.places.Autocomplete(locationRef.current, options);
                autocomplete.addListener("place_changed", () => {
                    const place = autocomplete.getPlace();
                    let newLocation = place.geometry.location;
                    setLocation({lat: newLocation.lat(), lng: newLocation.lng()});
                    setLocationKeyword(place.formatted_address);
                });
            });
            setInited(true);
        }

    }, [inited, show]);

    useEffect(() => {
        if (campsites != defaultCampsites) {
            setCampsites(defaultCampsites);
        }
        if (serviceAreas != defaultServiceAreas) {
            setServiceAreas(defaultServiceAreas);
        }
        if (parkingAreas != defaultParkingAreas) {
            setParkingAreas(defaultParkingAreas);
        }
        if (clubBenefits != defaultClubBenefits) {
            setClubBenefits(defaultClubBenefits);
        }
        if (attractions != defaultAttractions) {
            setAttractions(defaultAttractions);
        }
    }, [defaultCampsites, defaultServiceAreas, defaultParkingAreas, defaultClubBenefits, defaultAttractions]);

    const deletePoiKeyword = event => {
        event.preventDefault();
        setPoiKeyword('');
    };

    const deleteLocationKeyword = event => {
        event.preventDefault();
        setLocationKeyword('');
    };

    return <div className={'modal' + (show ? '' : ' hidden')} id="search_modal">
        <div className="modal-body" id="search_modal_body">
            <div className="modal-content">
                <div className="modal-header">
    
                    <a className="close-modal" onPointerDown={event => {
                                event.preventDefault();
                                event.stopPropagation();
                               }} onClick={event => {
                                   event.preventDefault();
                                   onGoBack();
                               }}></a>
                    <span onPointerDown={event => event.preventDefault()}>{strings.filter_result}</span>
                    <hr/>
                </div>
                <form action="/s">
                    <label>
                        <input type="search" id="search_what" className={"search" + (poiKeyword ? ' populated' : '')} placeholder={strings.what_searching} value={poiKeyword} onChange={onPoiKeywordChanged}/>
                        {poiKeyword ? <span className="clean" onClick={deletePoiKeyword}>x</span> : null}
    
                    </label>
                    <label>
                        <input type="search" id="search_where" className={"search" + (locationKeyword ? ' populated' : '')} placeholder={strings.where_searching} ref={locationRef} value={locationKeyword} onChange={onLocationKeywordChanged}/>
                        {locationKeyword ? <span className="clean" onClick={deleteLocationKeyword}>x</span> : null}
    
                    </label>
                    <hr/>
                    <div className="category-list">
                        <div id="campsites_category" className={'category ' + (campsites ? 'active' : '')} onClick={event => setCampsites(!campsites)}>
                            <CampsiteIcon/>
                            <div className="title">{strings.campsites}</div>
                        </div>
                        <div id="service_areas_category" className={'category ' + (serviceAreas ? 'active' : '')} onClick={event => setServiceAreas(!serviceAreas)}>
                            <ServiceAreaIcon/>
                            <div className="title">{strings.service_areas}</div>
                        </div>
                        <div id="parking_areas_category" className={'category ' + (parkingAreas ? 'active' : '')} onClick={event => setParkingAreas(!parkingAreas)}>
                            <ParkingAreaIcon/>
                            <div className="title">{strings.parking_areas}</div>
                        </div>
                        <div id="club_benefits_category" className={'category ' + (clubBenefits ? 'active' : '')} onClick={event => setClubBenefits(!clubBenefits)}>
                            <ClubBenefitIcon/>
                            <div className="title">{strings.club_benefits}</div>
                        </div>
                    </div>
                    <hr/>
                    <div className="subtitle">{strings.other_filters}</div>
                    <div className="filter-list">
                        <div className="label">{strings.attractions}
                            <input id="attractions_checkbox" className="custom-checkbox" type="checkbox" checked={attractions} onChange={event => setAttractions(!attractions)}/>
                            <label htmlFor="attractions_checkbox"></label>
                        </div>
                        <div className="label">{strings.disabled_accessibility}
                            <input id="disabled_accessibility_checkbox" className="custom-checkbox" type="checkbox" checked={disabledAccessibility} onChange={event => setDisabledAccessibility(!disabledAccessibility)}/>
                            <label htmlFor="disabled_accessibility_checkbox"></label>
                        </div>
                        <div className="label">{strings.pets_allowed}
                            <input id="pets_allowed_checkbox" className="custom-checkbox" type="checkbox" checked={petsAllowed} onChange={event => setPetsAllowed(!petsAllowed)}/>
                            <label htmlFor="pets_allowed_checkbox"></label>
                        </div>
                        <div className="label">{strings.water}
                            <input id="water_checkbox" className="custom-checkbox" type="checkbox" checked={water} onChange={event => setWater(!water)}/>
                            <label htmlFor="water_checkbox"></label>
                        </div>
                        <div className="label">{strings.cockpit}
                            <input id="cockpit_checkbox" className="custom-checkbox" type="checkbox" checked={cockpit} onChange={event => setCockpit(!cockpit)}/>
                            <label htmlFor="cockpit_checkbox"></label>
                        </div>
                        <div className="label">{strings.electricity}
                            <input id="electricity_checkbox" className="custom-checkbox" type="checkbox" checked={electricity} onChange={event => setElectricity(!electricity)}/>
                            <label htmlFor="electricity_checkbox"></label>
                        </div>
                    </div>
                    <button type="submit" className="btn" id="apply_button" onClick={onApplyClicked} disabled={!canApply}>{strings.apply_filter}</button>
                </form>
            </div>
        </div>
    </div>
};

export default SearchModal;
